// frontend_react/src/pages/admin/BankingPage.jsx

import React, { useEffect, useState } from "react";
import { PageContainer, PageTitle, Button, Table, ErrorText } from "../../ui";
import {
  downloadSepa,
  uploadCfonb120,
  getCaTransactions,
} from "../../services/bankingApi";
import { useAdminScope } from "../../context/AdminScopeContext";

export default function BankingPage() {
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState(null);
  const [loadingTransactions, setLoadingTransactions] = useState(false);
  const [uploadingCfonb, setUploadingCfonb] = useState(false);
  const [downloadingSepa, setDownloadingSepa] = useState(false);

  const { selectedCompanyUuid } = useAdminScope();

  const fetchTx = async () => {
    setLoadingTransactions(true);
    setError(null);

    try {
      const data = await getCaTransactions(
        "demo-token",
        {},
        {
          companyUuid: selectedCompanyUuid,
        }
      );

      const rows = data.transactions || data;
      setTransactions(rows || []);
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Erreur lors du chargement des transactions."
      );
    } finally {
      setLoadingTransactions(false);
    }
  };

  useEffect(() => {
    fetchTx();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompanyUuid]);

  const handleSepa = async () => {
    setDownloadingSepa(true);
    setError(null);

    try {
      await downloadSepa({
        companyUuid: selectedCompanyUuid,
      });
    } catch (err) {
      setError(
        err.response?.data?.error || "Erreur lors de la génération SEPA."
      );
    } finally {
      setDownloadingSepa(false);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadingCfonb(true);
    setError(null);

    try {
      await uploadCfonb120(file, {
        companyUuid: selectedCompanyUuid,
      });
      await fetchTx();
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de l'upload.");
    } finally {
      setUploadingCfonb(false);
    }
  };

  return (
    <PageContainer>
      <PageTitle>Banking</PageTitle>

      <div style={{ marginBottom: "1rem" }}>
        <Button onClick={handleSepa} disabled={downloadingSepa}>
          {downloadingSepa ? "Génération SEPA…" : "Générer SEPA"}
        </Button>

        <input
          aria-label="Upload CFONB"
          type="file"
          onChange={handleUpload}
          disabled={uploadingCfonb}
          style={{ marginLeft: "1rem" }}
        />
      </div>

      {loadingTransactions && (
        <p role="status">Chargement des transactions…</p>
      )}

      {uploadingCfonb && (
        <p role="status">Upload CFONB en cours…</p>
      )}

      {error && <ErrorText>{error}</ErrorText>}

      <Table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Libellé</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((t, i) => (
            <tr key={`${t.date}-${t.label}-${i}`}>
              <td>{t.date}</td>
              <td>{t.label}</td>
              <td>{t.amount}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </PageContainer>
  );
}